import {Box, Paper, Typography} from '@mui/material';
import React, {useContext, useEffect, useState} from 'react';
import IndicatorWorktime from './IndicatorWorktime';
import APIWrapperContext from '../../../../../services/APIWrapperContext';
import {ArbeitszeitService} from '../../../../../services/openapi';
import {addDaysToDate, convertDateToISODateString, getIsoWeekOfDate} from '../timehelperFunctions';
import {IWorktime} from './interfaces';
import LinkGeneratorForNFC from './LinkGeneratorForNFC';
import ExportWorkingData from './ExportWorkingData';
import WorkingDataOverview from './WorkingDataOverview';
import ZeiterfassungDashboardContextProvider from '../../../../../Contexts/ZeiterfassungDashboardContext/ZeiterfassungDashboardContextProvider';
import BauvorhabenAnlegen from './BauvorhabenAnlegen';
import BauvorhabenList from './BauvorhabenList';
import { useTranslation } from 'react-i18next';

export default function Dashboard() {
  const {call_backend_api} = useContext(APIWrapperContext);
  const [worktimes, setWorktimes] = useState<IWorktime[]>([]);
  let today = new Date();
  let days14ago = addDaysToDate(today, -14);
  let days28ago = addDaysToDate(today, -28);
  let days7ago = addDaysToDate(today, -7);

  useEffect(() => {
    call_backend_api(
      ArbeitszeitService.getAvgWorktimeArbeitzeitDashboardAvgWorktimePost(
        convertDateToISODateString(days28ago),
        convertDateToISODateString(today)
      ),
      (res: IWorktime[]) => {
        setWorktimes(res);
      },
      undefined,
      undefined,
      false
    );
  }, []);

  return (
    // <ThemeProvider theme={theme.palette.main}>
    <>
      {/* <Paper sx={{ display: "flex", flexDirection: "column", height:"100%" }}> */}
      <Box sx={{display: 'flex', flexDirection: 'column', height: '100%', p: 1, gap:4}}>
        <ZeiterfassungDashboardContextProvider>
          <WorkingDataOverview />
        </ZeiterfassungDashboardContextProvider>
        <BauvorhabenList />
        <LinkGeneratorForNFC />
      </Box>
      {/* </Paper> */}
    </>
    // </ThemeProvider>
  );
}
